import React from 'react';
import { TextField, styled } from '@mui/material';
import { Controller } from 'react-hook-form';
import { FormInputProps } from './FormInputProps';

const StyledTextField = styled(TextField)(({ theme }) => ({
  '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
    display: 'none',
  },
  '& input[type=number]': {
    MozAppearance: 'textfield',
  },
}));

/**
 * Percentage text field with % suffix and 0-100 range validation.
 */
export const InputPercentageTextField = (props: any) => {
  return <StyledTextField
    inputProps={{
      min: 0,
      max: 100,
      type: 'number',
    }}
    InputProps={{
      endAdornment: <>%</>,
      sx: {
        paddingRight: '8px', // Add padding to prevent overlap with border
      },
    }}
    {...props}
  />;
};

/**
 * Percentage input component with % suffix and 0-100 range validation.
 */
export const FormInputPercentage = ({ register, name, control, label, disabled, readOnly }: FormInputProps) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <StyledTextField
          sx={{
            maxWidth: 200,
          }}
          helperText={error ? error.message : undefined}
          error={!!error}
          label={label}
          onChange={onChange}
          value={value || ''}
          InputProps={{
            endAdornment: <>%</>,
            readOnly: readOnly,
            sx: {
              paddingRight: '8px', // Add padding to prevent overlap with border
            },
          }}
          InputLabelProps={{
            ...(disabled ? { shrink: true } : {}),
          }}
          fullWidth
          disabled={disabled}
          inputProps={{
            min: 0,
            max: 100,
            type: 'number',
          }}
        />
      )}
      {...register}
    />
  );
};
